import React, { useState, useEffect } from 'react';
import CompileComponent from './CompileComponent';
import Register from './Register';
import '../pages/main.css';
import { paymentContractAddress } from '../config';
import TwitterAbi from '../abi/Twitter.json';
import { Button, useNotification, Loading } from '@web3uikit/core';
import Web3Modal from "web3modal";
import { ethers, utils } from 'ethers';
import moneymanagement from '../images/money-management.png';
import search from '../images/search.png';
import rise from '../images/rise.png';
import usd from '../images/usd.png';
import system from '../images/system.png';
import wallet from '../images/wallet.png';
import { Route, Routes } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Benefits = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [paymentMade, setPaymentMade] = useState(false);
    const notification = useNotification();
    const [loading, setLoadingState] = useState(false);
    const [_isEligibleToDeploy, setIsEligibleToDeploy] = useState(false);
    const [_getLastPaymentRecordIndex, setLastPaymentRecordIndex] = useState();
    const [provider, setProvider] = useState(window.ethereum);
    const [_signerAddress, setSignerAddress] = useState();

    const handlePaymentMade = () => {
        setPaymentMade(true);
    };

    return (
        <>
            <div class="benefitsMain">

                <div class="header">Focus on tokenization use cases instead of coding</div>

                <div class="benefitsMain2" data-aos="fade" data-aos-duration="500">
                    <div class="b1">
                        <div><img src={moneymanagement}/><span className='bB'>Cutting edge technology: </span><br/> Token Tool is the leading token generator and lifecycle manager</div>
                        <div><img src={system}/><span className='bB'>Simple user experience:</span> <br/> Use our interface or an API for automation (enterprise only)</div>
                    </div>

                    <div class="b1">
                        <div><img src={wallet}/><span className='bB'>Simple and secure payment: </span><br/> Pay only for what you use directly from your wallet (no credit card or subscription required)</div>
                        <div><img src={usd}/><span className='bB'>Easy to use:</span> <br/> Effortlessly create, manage and track ERC20, and ERC721 tokens</div>
                    </div>

                    <div class="b1">
                        <div><img src={search}></img><span className='bB'>Smart contracts: </span><br/> Use our expert approved smart contracts instead of coding your own</div>
                        <div><img src={rise}/><span className='bB'>Enterprise version: </span><br/> Contact us for the enterprise version of Token Tool</div>
                    </div>

                </div>
            </div>

        </>
    );
};

export default Benefits;